import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PauseCircle, PlayCircle, ArrowRight, Layers } from "lucide-react";
import { api } from "../lib/api";
import { continueInChat } from "./ProjectionPanel";

const PHASE = { requirement: "Kebutuhan", intake: "Kebutuhan", planning: "Perencanaan", composition: "Penyusunan", execution: "Eksekusi", revision: "Revisi", handoff: "Ruang Kerja" };

export function ChatTasksCard() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/chat-tasks").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  if (!items || items.length === 0) return null;
  return (
    <section className="aivora-card p-5" data-testid="home-chat-tasks">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-base font-bold text-slate-900 md:text-lg"><Layers size={18} className="text-[#2F6BFF]" /> Tugas di Chat</h2>
        <span className="text-xs text-slate-400">{items.filter((t) => t.status === "active").length} aktif · {items.filter((t) => t.status === "paused").length} dijeda</span>
      </div>
      <div className="space-y-1">
        {items.slice(0, 6).map((t) => {
          const paused = t.status === "paused";
          return (
            <div key={`${t.conversation_id}-${t.paused_task_id || "live"}`} className="flex items-center gap-3 rounded-xl px-2 py-2.5 transition hover:bg-slate-50" data-testid={`chat-task-${t.paused_task_id || t.conversation_id}`}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg" style={{ background: paused ? "#F9731614" : "#2F6BFF14", color: paused ? "#F97316" : "#2F6BFF" }}>{paused ? <PauseCircle size={17} /> : <PlayCircle size={17} />}</span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-semibold text-slate-900" data-no-i18n>{t.title}</span>
                <span className="block truncate text-xs text-slate-400">{paused ? "Dijeda" : "Aktif"} · {PHASE[t.phase] || t.phase}{t.total ? ` · ${t.locked}/${t.total} bagian terkunci` : ""}{t.conversation_title ? ` · ${t.conversation_title}` : ""}</span>
              </span>
              <button onClick={() => continueInChat(nav, { conversation_id: t.conversation_id, title: t.title })} className="flex shrink-0 items-center gap-1 rounded-full border border-[#2F6BFF]/30 px-3 py-1 text-xs font-semibold text-[#2F6BFF] hover:bg-[#EEF3FF]" data-testid={`chat-task-continue-${t.paused_task_id || t.conversation_id}`}>Lanjutkan <ArrowRight size={12} /></button>
            </div>
          );
        })}
      </div>
    </section>
  );
}
